import classNames from "classnames"

const EndChatButton = ({ allowSubmitChat, submitCloseChat, text = "End Chat" }) => <button
    className={classNames(
        "px-8 py-2 text-[#FF7A1A] font-semibold text-lg transition-all relative z-10",
        {
            "opacity-50": !allowSubmitChat,
            "cursor-pointer": allowSubmitChat,
        }
    )}
    disabled={!allowSubmitChat}
    onClick={() => {
        submitCloseChat()
    }}
>
    {text}
</button>

export default EndChatButton